import script from "./OfferDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./OfferDetail.vue?vue&type=script&setup=true&lang=js"

import "./OfferDetail.vue?vue&type=style&index=0&id=46bd72bc&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.35_vue@3.5.35_typescript@5.9.3__webpack@5.107.2_4de69cea878ee2f242d39cab111b5a83/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-46bd72bc"]])

export default __exports__